"use client";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";

import { motion } from "framer-motion";
import { AnimatePresence } from "framer-motion";
// import { portfolioData } from "../../../data/portfolioData";
import React, { useState } from "react";
import Modal from "./ModalBlog";
import { useTranslation } from "react-i18next";

const CIUDADES_DESTACADAS = [
  "leon",
  "queretaro",
  "san luis",
  "aguascalientes",
];

const normalizarCiudad = (ciudad = "") =>
  (ciudad || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

export default function PortfolioThree({ desarrollos }) {
  const { t } = useTranslation();

  const fraccionamientos = desarrollos?.perfil?.fraccionamientos || [];
  const desarrollosDestacados = CIUDADES_DESTACADAS.map((ciudad) =>
    fraccionamientos.find((fraccionamiento) =>
      normalizarCiudad(fraccionamiento?.ciudad).includes(ciudad)
    )
  ).filter(Boolean);
  const [modalContent, setModalContent] = useState();
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      <div className="bostami-page-content-wrap">
        <div className="section-wrapper pl-60 pr-60 pt-60">
          <div className="bostami-page-title-wrap mb-15">
            <h2 className="page-title">{t('app.desarrollos')}</h2>
          </div>
        </div>

        <div className="section-wrapper pr-60 pl-60 mb-60">
          <div className="row">
            <div className="col-12">
              <div id="fillter-item-active" className="fillter-item-wrap ">
                <AnimatePresence>
                  <ResponsiveMasonry
                    columnsCountBreakPoints={{
                      350: 1,
                      850: 2,
                      1100: 3,
                      1200: 2,
                    }}
                  >
                    <Masonry gutter="20px">
                      {desarrollosDestacados.map((elm) => (
                        <motion.div
                          layout
                          initial={{ opacity: 0, scale: 0 }}
                          animate={{ opacity: 1, scale: 1 }}
                          exit={{ opacity: 0, scale: 0.5 }}
                          transition={{ duration: 0.3 }}
                          key={elm.id}
                          className={elm.class}
                          style={{ width: "100%" }}
                        >
                          <div
                            style={{ width: "100%" }}
                            className={`fillter-item ${elm.bgClass}`}
                          >
                            <button
                              type="button"
                              className="development-card-trigger"
                              aria-label={elm.nombre}
                              onClick={() => {
                                setModalContent(elm);
                                setShowModal(true);
                              }}
                            >
                              <span className="img">
                                <img
                                  width={310}
                                  height={310}
                                  src={elm.banner}
                                  alt=""
                                />
                              </span>
                              <span className="item-subtitle">
                                {elm.ciudad}
                              </span>
                              <span className="item-title">{elm.nombre}</span>
                            </button>
                          </div>
                        </motion.div>
                      ))}
                    </Masonry>
                  </ResponsiveMasonry>
                </AnimatePresence>
              </div>
            </div>
          </div>
        </div>


      </div>
      <Modal
        setShowModal={setShowModal}
        showModal={showModal}
        modalContent={modalContent}
      />
    </>
  );
}
